import {
  faBars,
  faSignOut,
  faUser
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Container, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import "./style.css";

import { useGetNotificationsQuery } from "../../../Redux/Apis/Notification";
import { logout } from "../../../Redux/Slices/Auth";
import CustomModal from "../../CustomModal";
import NeighborhoodSelector from "../../NeighborhoodSelector";
import { placeholderImage } from './../../../Assets/images/';

export const Header = (props) => {

  const { data, isLoading } = useGetNotificationsQuery()

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.authSlice)
  if (user) {
    var { profile_photo, name } = user
  }

  const [notificationState, setNotificationState] = useState([])
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);


  const Continue = () => {
    setShowModal(false)
    setShowModal2(true)
  }

  const handleClickPopup = () => {
    setShowModal(true)
  }

  const handleRedirect = () => {
    navigate('/');
    dispatch(logout())
  }


  useEffect(() => {
    if (data) {
      setNotificationState(data.data)
    }
  }, [data])

  return (
    <header>
      <div className="customHeader">
        <Container fluid className="fluid-con">
          <div className="headerBrand">
            <button className="headerMenuButton notButton" onClick={props.sidebarToggle} aria-label="Toggle sidebar">
              <FontAwesomeIcon icon={faBars} />
            </button>
            <div className="headerBrandCopy">
              <h1 className="headerTitle">Admin Console</h1>
            </div>
          </div>

          <div className="headerControls">
            <NeighborhoodSelector />
            <Dropdown className="userDropdown">
              <Dropdown.Toggle
                variant="transparent"
                className="notButton toggleButton"
              >
                <div className="userMeta">
                  <div className="userMetaText">
                    <span className="userMetaLabel">Signed in as</span>
                    <span className="userMetaName">{name || "Admin"}</span>
                  </div>
                  <div className="userImage">
                    <img
                      src={profile_photo ? `${process.env.REACT_APP_IMAGE_ENDPOINT}${profile_photo}` : placeholderImage}
                      alt={name || "Admin"}
                      className="img-fluid rounded-circle"
                    />
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="userMenu" align="end">
                <Link className="userMenuItem" to={'/profile'}>
                  <FontAwesomeIcon
                    className="me-2 yellow-text"
                    icon={faUser}
                  />
                  Profile
                </Link>
                <Link to="#" className="userMenuItem" onClick={handleClickPopup}>
                  <FontAwesomeIcon
                    className="me-1 yellow-text"
                    icon={faSignOut}
                  />
                  Logout
                </Link>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Container>
      </div>

      <CustomModal show={showModal} close={() => { setShowModal(false) }} action={Continue} heading='Are you sure you want to logout?' />
      <CustomModal show={showModal2} close={handleRedirect} success heading='Successfully Logged Out' />
    </header>
  );
};
